import Section from 'app/frontend/base/components/Section'
import { useTeam } from 'app/frontend/base/config/context/team'
import { Route, Routes } from 'react-router-dom'
import TeamPlanEditor from './components/TeamPlanEditor'
import TeamPlansOverview from './components/TeamPlansOverview'

const TeamPlans = () => {
  const { team, guild } = useTeam()

  return (
    <Section title={`Plans | ${team.name} | ${guild.name}`}>
      <Routes>
        <Route path='/' element={<TeamPlansOverview />} />
        <Route path='/:planId' element={<TeamPlanEditor />} />
      </Routes>
    </Section>
  )
}

export default TeamPlans
